// ABOUTME: Zod schemas for TechLog user API responses
import { z } from 'zod';

/**
 * TechLog user response schema (from GET /v1/users/{id})
 */
export const ZTechlogUser = z.object({
  id: z.string(),
  operatorId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  position: z.string().nullable(),
  employeeNumber: z.string().nullable(),
  amosUserSign: z.string().nullable(),
  status: z.string(),
  hasLogin: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type TechlogUserZod = z.infer<typeof ZTechlogUser>;
